var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFollowerVine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 569,
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#065e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#328e72"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2048") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    display: "inline"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m298.26,4.79c22.59,10.5 19.11,54.86 11.63,71.79c-7.48,16.93 -23.98,18.2 -45.63,10.32c-21.65,-7.87 -46.85,-23.62 -75.59,-24.41c-28.74,-0.79 -96.85,9.06 -101.97,60.63c-5.12,51.57 24.02,77.17 46.06,76.77c22.05,-0.39 51.18,-35.43 59.06,-42.91c7.87,-7.48 36.61,-25.98 64.57,-18.11c27.95,7.87 49.21,42.91 35.43,77.56c-13.78,34.65 -20.47,48.43 -20.94,65.06c-0.47,16.64 11.89,52.65 11.89,73.13c0,20.47 -11.42,63.78 -48.11,72.15c-36.69,8.37 -153.07,1.47 -195.28,23.62c-42.2,22.15 -47.56,71.94 -7.09,92.52c40.47,20.57 142.2,11.31 164.57,8.27c22.36,-3.05 84.72,-18.21 95.67,-55.51c10.94,-37.3 -33.78,-83.17 -85.43,-91.73c-51.65,-8.56 -79.06,32.57 -118.5,17.72c-39.45,-14.86 -44.8,-68.61 -10.63,-83.86c34.17,-15.25 40.63,5.8 87.8,3.15c47.17,-2.65 61.5,-29.24 62.99,-55.51c1.5,-26.28 -32.99,-54.83 -65.75,-51.18c-32.76,3.65 -53.07,36.12 -90.94,11.42c-37.87,-24.7 -48.74,-54.43 -55.04,-85.93c-6.3,-31.5 -22.44,-129.13 20.39,-139.66c42.83,-10.53 64.25,6.2 98.11,6.2c33.86,0 140.15,-31.99 162.75,-21.49z",
    fill: "#ff0000",
    fillOpacity: 0.01,
    id: "svg_16",
    stroke: "#f90000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFollowerVine2);
export default __webpack_public_path__ + "static/media/mobileFollowerVine2.1c6a61be1f872bddd0410c26325e756c.svg";
export { ForwardRef as ReactComponent };